import StyledLink from '../StyledLink'
import { ENVIRONMENTS } from '../routes'
import type { Props } from '../types'

const LinkToSpaceEnvironments = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={'/' + ENVIRONMENTS}
  >
    {children}
  </StyledLink>

export default LinkToSpaceEnvironments
